// node_modules
import React, { useState, useEffect, useRef, createContext } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";

// pages
import ChefPortal from "./pages/Chef/ChefPortal";
import StudentPortal from "./pages/Student/StudentPortal";
import ManagerPortal from "./pages/Manager/ManagerPortal";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import Login from "./pages/Login/Login";
import StatusScreen from "./pages/StatusScreen/StatusScreen";

// redux
import { useGetVersionQuery } from "./redux/services/app";

// components
import Header from "./components/Header";
import PrivateRoute from "./components/PrivateRoute";
import Loader from "./components/Loader/Loader";

// primereact components
import { Toast } from "primereact/toast";

// styles
import * as styles from "./App.module.css";

export const ToastContext = createContext();

const App = () => {
  const toastRef = useRef(null);

  const { data: version, isSuccess } = useGetVersionQuery();

  const showToast = (severity, summary, detail) => {
    if (toastRef.current) {
      toastRef.current.show({ severity, summary, detail, life: 3000 });
    }
  };

  return (
    <PrimeReactProvider>
      <BrowserRouter>
        <ToastContext.Provider value={showToast}>
          <Toast ref={toastRef} />
          <Header />
          <Loader />
          <div
            style={{
              position: "fixed",
              right: 0,
              bottom: 0,
              fontSize: "10px",
              zIndex: 100000,
            }}
          >
            F{process.env.REACT_APP_VERSION}/B{version}
          </div>
          <Routes>
            <Route path="/*" element={<StudentPortal />} />

            <Route path="/login" element={<Login />} />

            <Route
              path="/station/:stationId/status"
              element={<StatusScreen />}
            />

            <Route
              path="/app/chef/*"
              element={
                <PrivateRoute allowedRoles={["chef", "admin", "manager"]}>
                  <ChefPortal />
                </PrivateRoute>
              }
            />
            <Route
              path="/app/manager/*"
              element={
                <PrivateRoute allowedRoles={["manager", "admin"]}>
                  <ManagerPortal />
                </PrivateRoute>
              }
            />
            <Route
              path="/app/admin/*"
              element={
                <PrivateRoute allowedRoles={["admin"]}>
                  <AdminDashboard />
                </PrivateRoute>
              }
            />
          </Routes>
        </ToastContext.Provider>
      </BrowserRouter>
    </PrimeReactProvider>
  );
};

export default App;
